import { ClipboardList, Handshake, MailCheck, Sparkles } from "lucide-react";

interface Props {
  /** Tjänstens namn, t.ex. "solceller" – används i texterna */
  serviceLabel: string;
}

const steps = (label: string) => [
  {
    icon: ClipboardList,
    title: "1. Beskriv ditt behov",
    text: `Svara på några snabba frågor om din bostad och vad du vill ha ut av ${label.toLowerCase()}. Det tar under en minut.`,
  },
  {
    icon: Handshake,
    title: "2. Vi matchar leverantörer",
    text: "Vi matchar din förfrågan mot kvalitetssäkrade leverantörer som arbetar i ditt område.",
  },
  {
    icon: MailCheck,
    title: "3. Jämför offerter",
    text: "Du får upp till fyra kostnadsfria offerter att jämföra i lugn och ro – helt utan förpliktelser.",
  },
];

/** Förklarande "Så fungerar det"-sektion på kategorisidor för offertjämförelser */
const HowQuotesWork = ({ serviceLabel }: Props) => (
  <section aria-labelledby="sa-fungerar-det">
    <div className="mx-auto mb-8 max-w-2xl text-center md:mb-10">
      <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-1.5 text-sm font-medium text-primary">
        <Sparkles size={16} />
        Kostnadsfritt och utan förpliktelser
      </div>
      <h2 id="sa-fungerar-det" className="heading-2 text-foreground mt-4">
        Så fungerar det
      </h2>
      <p className="mt-3 text-muted-foreground">
        Tre enkla steg från förfrågan till jämförbara offerter på {serviceLabel.toLowerCase()}.
      </p>
    </div>

    <div className="grid gap-5 sm:grid-cols-3 md:gap-6">
      {steps(serviceLabel).map((step) => (
        <div
          key={step.title}
          className="flex h-full flex-col rounded-2xl bg-card p-6 shadow-md transition-shadow hover:shadow-lg md:p-7"
        >
          <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <step.icon size={20} />
          </div>
          <h3 className="heading-3 text-foreground mb-2">{step.title}</h3>
          <p className="text-sm leading-relaxed text-muted-foreground">{step.text}</p>
        </div>
      ))}
    </div>
  </section>
);

export default HowQuotesWork;
